import $Util from '../../common/util.js';
export default {
	state:{
		radio1: '上海',
		title: "",
		cetagory: [],
		desc:"",
		stock:0,
		input:'',
		is_shangjia:0, 
		post_model:'',
		checkboxGroup2: [],
		// 规格卡片
		sku_card:[
			{
				name:'颜色',
				type:2,
				list:[
					{
						name:'红色',
						image:'',
						color:''
					},
					{
						name:'黄色',
						image:'',
						color:''
					}
				]
			}
		]
	},
	getters:{
		
	},
	mutations:{
		// 修改
		vModelState(state,{key,value}){
			state[key] = value
		},
		// 增加规格卡片
		addSkuCard(state){
			state.sku_card.push({
				name:'规格名稱',
				type:0,
				list:[]
			})
		},
		// 删除卡片
		delSkuCard(state,index){
			state.sku_card.splice(index,1)
		},
		// 修改卡片
		vModelSkuCard(state,{key,index,value}){
			state.sku_card[index][key] = value
		},
		// 卡片排序
		sortSkuCard(state,{action,index}){
			// 上移
			$Util[action] (state.sku_card,index)
		},
		//增加指定规格卡片的指定属性
		addSkuValue(state,index){
			state.sku_card[index].list.push({
				name:'规格名稱',
				image:'',
				color:''
			})
		},
		// 删除指定规格卡片的指定属性
		delSkuValue(state,{cardIndex,index}){
			console.log(state.sku_card)
			console.log(cardIndex)
			console.log(index)
			state.sku_card[cardIndex].list.splice(index,1)
		},
		// 修改指定规格卡片的指定属性
		updateSkuCard(state,{cardIndex,index,key,value}){
			state.sku_card[cardIndex].list[index][key] = value
		},
		// 修改指定规格卡片的指定属性的跑徐
		sortSkuCard(state,{index,value}){
			state.sku_card[index].list = value
			console.log(JSON.stringify(state.sku_card[index].list))
		}
	},
	actions:{
		
	}
}